import { render, staticRenderFns } from "./RsQuestionSingleSelect.vue?vue&type=template&id=161cfae1"
import script from "./RsQuestionSingleSelect.vue?vue&type=script&lang=js"
export * from "./RsQuestionSingleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports